import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//external
import { NgZorroModule } from "@ng-zorro/ng-zorro.module";
import { ConfirmDialogComponent } from '@shared/components/modal/confirm-dialog/confirm-dialog.component';
import { ButtonComponent } from '@shared/components/button/button.component';
import { InputComponent } from '@shared/components/input/input.component';
import { InputFileComponent } from '@shared/components/input-file/input-file.component';
import { SelectComponent } from '@shared/components/select/select.component';
import { IconComponent } from './components/icon/icon.component';
import { ChipComponent } from './components/chip/chip.component';
import { CardComponent } from './components/card/card.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { InputEffectDirective } from './directives/input-effect.directive';
import { OnlyLettersDirective } from './directives/only-letters.directive';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { AlfaNumericDirective } from './directives/alfa-numeric.directive';
import { RemovefirstspaceDirective } from './directives/removefirstspace.directive';
import { TableComponent } from './components/table/table.component';
import { SortDirective } from './directives/sort.directive';
import { RemoveSpacesDirective } from './directives/remove-spaces.directive';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { PreventDragAndDrogDirective } from './directives/prevent-drag-and-drog.directive';
import { FlowCardComponent } from './components/flow-card/flow-card.component';
import { SwitchComponent } from './components/switch/switch.component';
import { TextAreaComponent } from './components/text-area/text-area.component';
import { GlobalFilterPipe } from './pipes/global-filter.pipe';
import { DeleteModalComponent } from './components/modal/delete-modal/delete-modal.component';
import { NoTildeDirective } from './directives/no-tilde.directive';

const COMPONENTS = [
  ButtonComponent,
  InputComponent,
  InputFileComponent,
  SelectComponent,
  IconComponent,
  ChipComponent,
  CardComponent,
  NavbarComponent,
  TableComponent,
  FlowCardComponent,
  TextAreaComponent
];

const DIALOG = [
  ConfirmDialogComponent,
  DeleteModalComponent
]

const DIRECTIVES = [
  InputEffectDirective,
  RemovefirstspaceDirective,
  SortDirective,
  OnlyLettersDirective,
  OnlyNumbersDirective,
  AlfaNumericDirective,
  RemoveSpacesDirective,
  RemovefirstspaceDirective,
  PreventDragAndDrogDirective,
  SwitchComponent,
  NoTildeDirective,
]

const PIPES = [
  GlobalFilterPipe
]

@NgModule({
  declarations: [
  ...COMPONENTS,
  ...DIALOG,
  ...DIRECTIVES,
  ...PIPES,
    GlobalFilterPipe,
  ],
  imports: [
    CommonModule,
    NgZorroModule
  ],
  exports: [
  ...COMPONENTS,
  ...DIALOG,
  ...DIRECTIVES,
  ...PIPES,
  GlobalFilterPipe,
  ]
})
export class SharedModule { }
